// Components==============
import Button from 'components/UI/Button';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import AgendaCard from '../AgendaCard';
import './index.module.scss';
// =========================

export default function Agenda({
    buttonBackground = '#1E265C',
    buttonColor = '#FFFFFF',
    home,
    network,
}) {
    const history = useHistory();
    const events = useSelector((state) =>
        state?.events?.entities?.allIds?.map(
            (id) => state?.events?.entities?.byId[id]
        )
    );
    const allEvents = [...events]
        .filter((agenda) => agenda.start_date !== null)
        .sort(
            (a, b) =>
                new Date(a.start_date || a.date) -
                new Date(b.start_date || b.date)
        )
        ?.filter(
            (agenda) => new Date(agenda.date || agenda.start_date) >= new Date()
        )
        ?.filter((agenda) => (network ? agenda.is_network_event : true))
        ?.filter((item, i) => i < 3);

    // format date
    const formattedDate = (date) => {
        const d = new Date(date);
        const month = d.toLocaleString('nl-NL', {
            timeZone: 'Europe/Amsterdam',
            month: 'long',
        });
        const day = d.toLocaleString('nl-NL', {
            timeZone: 'Europe/Amsterdam',
            day: 'numeric',
        });
        const year = d.toLocaleDateString('nl-NL', {
            timeZone: 'Europe/Amsterdam',
            year: 'numeric',
        });
        return `${day} ${month} ${year}`;
    };

    return (
        <div styleName={`container ${home ? 'home' : ''}`}>
            <h2
                style={{
                    marginBottom: '1rem',
                    paddingLeft: '0.3rem',
                    marginTop: '0.4rem',
                }}
            >
                Agenda
            </h2>
            <div styleName="wrapper">
                {allEvents.length === 0 ? (
                    <>
                        {network ? (
                            <p>
                                We zijn druk bezig met het organiseren van
                                netwerkbijeenkomsten. Zodra er meer bekend is,
                                vind je ze hier.{' '}
                            </p>
                        ) : (
                            <p>Geen agenda items</p>
                        )}
                    </>
                ) : (
                    <>
                        {allEvents.map((item, i) => (
                            <AgendaCard
                                network={network}
                                key={i}
                                title={item.title || item.name}
                                date={formattedDate(
                                    item.date || item.start_date
                                )}
                                id={item.id}
                            />
                        ))}
                    </>
                )}
            </div>
            <div styleName="btn">
                <Button
                    onClick={() => {
                        if (network) {
                            localStorage.setItem('networkCheckbox', true);
                            history.push('/agenda');
                        } else {
                            history.push('/agenda');
                        }
                    }}
                    background={buttonBackground}
                    color={buttonColor}
                    style={{ width: 'max-content' }}
                >
                    Agendaoverzicht
                </Button>
            </div>
        </div>
    );
}
